module.exports = __webpack_public_path__ + "img/banner01_it.9ae477e6.jpg";